import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";


import AuthenticationService from '../../service/authentication_service';

class HeaderComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dashboard: props.dashboard,
        };
    }


    logout = () => {
        AuthenticationService.clearLocalstorage();
    }
    render() {
        return (
            <div className="section-header demo-section-bg text-white">
                <div className="demo-navbar">
                    <div className="container">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="div">
                                <a className="demo-logo" href="index.html"><img src="/assets/images/logo-light2x.png" alt="TokenWiz" /></a>
                            </div>
                            <div className="d-none">
                                <a href="#" className="demo-menu-toggler"><em className="ti ti-align-right" /></a>
                            </div>
                            <div className="demo-menu-wrap d-none d-lg-block">
                                <ul className="demo-navbar-menu">
                                    <li><a className="to-section" href="#showcase">Demo Showcase</a></li>
                                    <li><a className="to-section" href="#features">Features</a></li>
                                    <li><a className="to-section" href="#request-feature">Request A Feature</a></li>
                                    <li><Link  to={AuthenticationService.getToken() ?"/dashboard" : "/signin"} className="btn btn-primary ucap">{AuthenticationService.getToken() ?"Dashboard":"Login"}</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-gaps mgmt-4x">
                    <div className="container">
                        <div className="row justify-content-between align-items-center">
                            <div className="col-lg-6">
                                <div className="header-text">
                                    <h1>UnifiedAuth</h1>
                                    <p></p>
                                    <div className="gaps-3x" />
                                    {/* <p className="text-danger text-itatlic"><small><em>Unif</em></small></p> */}
                                    <div className="gaps-0-5x" />
                                </div>
                                <div className="gaps-2x d-lg-none" />
                            </div>
                            <div className="col-lg-5 d-none d-lg-block">
                                <div className="header-img mgmr-3x">
                                    <img src="https://portswigger.net/web-security/images/password-reset-poisoning.svg" alt="image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(HeaderComponent);
